import { createSelector } from '@reduxjs/toolkit';

import { isMoscowOrMO } from 'shared/utils/isMoscowOrMO';

import { getFilters } from '../filters/getFilters';

export const selectIsMoscowOrMO = createSelector(getFilters, state => isMoscowOrMO(state.location));
